/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetYoutubePlaylistsQueryResponse, GetYoutubePlaylistsPathParams } from "../models/GetYoutubePlaylists";

export function getGetYoutubePlaylistsUrl(station: GetYoutubePlaylistsPathParams["station"]) {
  const res = { method: 'GET', url: `/youtube/${station}/playlists` as const }
  return res
}

/**
 * @description Returns all playlists owned by the authenticated user for the station
 * @summary Get YouTube playlists for a station
 * {@link /youtube/:station/playlists}
 */
export async function getYoutubePlaylists(station: GetYoutubePlaylistsPathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetYoutubePlaylistsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetYoutubePlaylistsUrl(station).url.toString(), ... requestConfig })
  return res.data
}